import { Injectable } from '@angular/core';

import { ActivityTrackerService } from './activity-tracker.service';
import {StorageService} from "./storage.service";
import { InfoDialogService } from './modal/info-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private tracker: ActivityTrackerService,
		private storageService: StorageService,
        private infoDialogService: InfoDialogService
	) {
	}

  sendReport() : void {
		
		const uploadResult = this.storageService.uploadText(JSON.stringify(this.tracker.getActivityLog(), null, 2));

        uploadResult.progress$.subscribe({
            next: progress => {
                console.log(`Upload progress: ${progress}%`);
            },
            error: err => {
                console.error('Upload error:', err);
            },
            complete: () => {
                console.log('Upload complete');
                alert("Vielen Dank. Der Fehlerbericht wurde erfolgreich gesendet.");

            // let msg: string = "Vielen Dank. Der Fehlerbericht wurde erfolgreich gesendet.";
            // let details: string = `${JSON.stringify(this.documentMetadata.jadeDocumentInfo)} ${JSON.stringify(this.documentMetadata.jadeDocumentError)}`
            // var businessError = { message: msg, details, title: "Fehlermeldung: Datei-Upload fehlgeschlagen:"};
            // this.infoDialogService.openDialog(businessError);
            }
        });

        uploadResult.downloadUrl$.subscribe({
            next: url => {
                console.log('Download URL:', url);
            },
            error: err => {
                console.error('Download URL error:', err);
            }
        });
		
	}
}
